import VolumeSlider from '../../volume-slider'

import * as Styled from './styled'
import * as ParentStyled from '../styled'
import { memo } from 'react'
import { T } from 'consts/translationKeys'
import { FadeSlider } from '../../fade-slider'

interface IProps {
  hideDivideLine?: boolean
}

const MusicVersioningTopSection: React.FC<IProps> = ({ hideDivideLine }) => {
  return (
    <Styled.TopSection>
      <VolumeSlider />
      <FadeSlider label={T.FADE_IN_LABEL} type="fade-in" />
      <FadeSlider label={T.FADE_OUT_LABEL} type="fade-out" />
      {!hideDivideLine && <ParentStyled.DivideLine />}
    </Styled.TopSection>
  )
}

export default memo(MusicVersioningTopSection)
